package com.patronat.top.features.auth.domain.usecase

import com.patronat.top.core.auth.TokenStorage
import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.core.domain.usecase.command.auth.ConfirmPhoneCommand
import com.patronat.top.core.network.asDomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.AuthSuccessResponse
import com.patronat.top.features.auth.data.mappers.toDomain
import com.patronat.top.features.auth.domain.models.AuthResult
import com.patronat.top.features.auth.domain.repository.AuthRepository

class ClientConfirmPhoneUseCase(
    private val repository: AuthRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<ConfirmPhoneCommand, DomainResult<AuthResult>>(
    dispatcher = dispatcherProvider.io
) {

    override suspend fun doWork(command: ConfirmPhoneCommand): DomainResult<AuthResult> {
        return repository.confirmPhone(command)
    }
}